import ArrayProxy from "@ember/array/proxy"
import { action, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { CardStack } from "@shared/models/card-stack"
import type { Course } from "@shared/models/course"
import { extractCardStackTemplateIds } from "cc-frontend/utils/filter-dates/course"
import { compact, includes, isNil, map } from "lodash-es"
import styles from "./item.module.css"
const ArrayPromiseProxy = ArrayProxy.extend(PromiseProxyMixin)

interface Args {
  courses: ArrayProxy<Course>
  cardStackTemplate: CardStack
  deleteTemplate: Function
}

export default class CourseTemplateItemComponent extends Component<Args> {
  readonly styles = styles

  /**
   * loops through courses
   * gets the templateIds
   * maps and returns true or false if it has the template
   * compact takes out the false values
   * return length
   */
  get countOfCoursesUsingTemplate() {
    if (isNil(this.args.cardStackTemplate)) return 0
    // @ts-ignore The compact type signature isn't recognizing the ember like array as a list. It is.
    let courses = compact(get(this.args.courses, "content"))
    if (isNil(courses)) return 0

    return compact(
      map(
        map(courses, (course) => {
          return extractCardStackTemplateIds(course)
        }),
        (templateIds) => {
          return includes(templateIds, get(this.args.cardStackTemplate, "id"))
        }
      )
    ).length
  }

  get hasTemplates() {
    return this.countOfCoursesUsingTemplate > 0
  }

  @tracked menuIsOpen = false
  @action toggleMenu() {
    this.menuIsOpen = !this.menuIsOpen
  }

  @action deleteTemplate() {
    this.menuIsOpen = false
    this.args.deleteTemplate()
  }
}
